import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13513f68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-3 bg-white border-top border-bottom border-gray-03" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "責任者", -1))
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n        仕事内容\n      ", -1))
const _hoisted_5 = { class: "operation-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreetingMessage = _resolveComponent("GreetingMessage")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createTextVNode(),
      _createVNode(_component_GreetingMessage, {
        class: "mt-2",
        firstName: _ctx.getOfficeProp('managerFirstName'),
        lastName: _ctx.getOfficeProp('managerLastName'),
        personImage: _ctx.managerAvatar,
        message: _ctx.getOfficeProp('greetingMessage')
      }, null, 8, ["firstName", "lastName", "personImage", "message"])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (operation) => {
          return (_openBlock(), _createBlock(_component_Tag, {
            key: operation.id,
            label: operation.name,
            class: "bg-light-yellow border-yellow text-primary-dark"
          }, null, 8, ["label"]))
        }), 128))
      ]),
      _createTextVNode(),
      (_ctx.operations.length === 0)
        ? _renderSlot(_ctx.$slots, "unsetOperations", { key: 0 }, undefined, true)
        : _createCommentVNode("", true)
    ])
  ]))
}